<template>
  <div style="max-width: 480px;" class="mx-auto bg-light d-flex justify-content-around align-items-center fixed-bottom shadow-lg border border-top">
    <router-link
      v-if="currentRole === 'individual'"
      to="/package"
      class="text-center btn-click-effect text-decoration-none"
      :class="{ 'text-primary': selectedMenu === 'Package', 'text-black': selectedMenu !== 'Package' }"
      style="font-size: 8pt">
      <i class="bi bi-box" style="font-size: 1.8em !important"></i> <br />
      {{ $t('bottomNav.home') }}
    </router-link>
    <router-link
      to="/transactions"
      class="text-center btn-click-effect text-decoration-none"
      :class="{ 'text-primary': selectedMenu === 'Transactions', 'text-black': selectedMenu !== 'Transactions' }"
      style="font-size: 8pt">
      <i class="bi bi-wallet" style="font-size: 1.8em !important"></i> <br />
      {{ $t('bottomNav.transaction') }}
    </router-link>
    <router-link
      to="/profile"
      class="text-center btn-click-effect text-decoration-none"
      :class="{ 'text-primary': selectedMenu === 'Profile', 'text-black': selectedMenu !== 'Profile' }"
      style="font-size: 8pt">
      <i class="bi bi-person" style="font-size: 1.8em !important"></i> <br />
      {{ $t('bottomNav.profile') }}
    </router-link>
    <a
      href="https://wa.me/+628122082122"
      class="text-black text-decoration-none text-center btn-click-effect"
      style="font-size: 8pt">
      <i class="bi bi-whatsapp" style="font-size: 1.8em !important"></i> <br />
      {{ $t('bottomNav.callCenter') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  computed: {
    selectedMenu() {
      return this.$store.getters.whatMenu
    },
    currentRole() {
      return this.$store.getters.getRole
    }
  }
}
</script>

<style scoped></style>
